import type { ComponentType } from 'react';

import {
  CalendarPlusIcon,
  FolderIcon,
  type IconProps,
  MessageIcon,
  TicketIcon,
  UserIcon,
} from '@/shared/ui';

export interface TabDefinition {
  /** The address, and the i18n key suffix — one identifier, not two. */
  readonly key: 'booking' | 'appointments' | 'messages' | 'consult' | 'records' | 'account';
  readonly path: string;
  readonly icon: ComponentType<IconProps>;
}

/**
 * The destinations, named for what is inside them rather than for a vague
 * umbrella: "نوبت‌گیری" and "نوبت‌های من" say what you will find, where a
 * generic "خانه" would say nothing (§16 — direct, specific labels).
 *
 * The order is the patient's own order of need: book first, then check what you
 * booked, then settings. It never changes — a tab that moves is a tab that has
 * to be re-found every visit.
 *
 * «پرونده» is deliberately absent for now. The page and its i18n keys still
 * exist; showing it again is one entry here (with `FolderIcon`, between
 * appointments and account) plus its route in `app/router/routes.tsx`.
 */
export const TABS: readonly TabDefinition[] = [
  { key: 'booking', path: '/', icon: CalendarPlusIcon },
  { key: 'appointments', path: '/appointments', icon: TicketIcon },
  // «پیام‌ها» — notices from the clinic; carries the unread count
  { key: 'messages', path: '/messages', icon: MessageIcon },
  // «مشاوره» — بررسی آزمایش and the phone consultation, with their history
  { key: 'consult', path: '/consult', icon: FolderIcon },
  { key: 'account', path: '/account', icon: UserIcon },
];
